import React from 'react';
import { useSelector } from 'react-redux';

import { Table, Typography } from 'antd';
import { columnSearchWidget } from 'components';
import '../../../../style/table_styles.css';
import { selectors } from 'state';

const IndexFundsTable: React.FC = () => {
  const session = useSelector(selectors.activeSession);
  const eligibleOptions = session.eligible_benchmark_options;
  const indexFundsData = eligibleOptions?.index_funds || [];
  const equities = eligibleOptions?.equities || [];
  const waiting = session.eligible_benchmark_options_waiting;

  return (
    <div>
      <Typography.Title level={4}>Index Funds</Typography.Title>

      <div
        className="sticky-table-container"
        // style={{ minWidth: '95%', width: 'max-content' }}
      >
        <Table
          rowKey="id"
          bordered
          loading={waiting}
          pagination={false}
          dataSource={indexFundsData}
          className={'index-funds-table'}
          style={{
            // width: 1000,
            // minWidth: '95%',
            // width: 'max-content',
            maxHeight: '30vh',
          }}
          columns={[
            {
              title: 'Issuer Name',
              dataIndex: 'issuer_name',
              ...columnSearchWidget({
                dataIndex: 'issuer_name',
              }),
              width: 240,
            },
            {
              title: 'Index',
              dataIndex: 'name',
              ...columnSearchWidget({
                dataIndex: 'name',
              }),
            },
            {
              title: 'RIC',
              dataIndex: 'ric',
              ...columnSearchWidget({
                dataIndex: 'ric',
              }),
              width: 150,
            },
          ]}
        />
      </div>
      <br />
      <Typography.Title level={4}>Equities</Typography.Title>
      <div
        className="sticky-table-container"
        // style={{ minWidth: '95%', width: 'max-content' }}
      >
        <Table
          rowKey="id"
          bordered
          loading={waiting}
          pagination={false}
          dataSource={equities}
          className={'index-funds-table'}
          style={{
            // width: 600,
            // minWidth: '95%',
            // width: 'max-content',
            maxHeight: '30vh',
          }}
          columns={[
            // {
            //   title: 'Issuer Name',
            //   dataIndex: 'issuer_name',
            //   ...columnSearchWidget({
            //     dataIndex: 'ric',
            //   }),
            //   width: 240,
            // },
            {
              title: 'Name',
              dataIndex: 'name',
              ...columnSearchWidget({
                dataIndex: 'name',
              }),
            },
            {
              title: 'RIC',
              dataIndex: 'ric',
              ...columnSearchWidget({
                dataIndex: 'ric',
              }),
              width: 150,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default IndexFundsTable;
